import {useMemo} from 'react';
import {throttle} from 'lodash';
import type {ThrottleOptions} from '../throttle';
import useLatest from '../latest';
import useUnmount from '../unmount';

function useThrottleFn<T extends Func>(fn: T, options?: ThrottleOptions) {
    const fnRef = useLatest(fn);
    const wait = options?.wait ?? 1000;
    const throttled = useMemo(() => throttle(
        (...args: Parameters<T>): ReturnType<T> => fnRef.current(...args),
        wait,
        options
    ), []);

    useUnmount(() => {
        throttled.cancel();
    });

    return {
        run: throttled,
        cancel: throttled.cancel,
        flush: throttled.flush
    };
}

export default useThrottleFn;